export default "__VITE_ASSET__6645ebb8__"